export default "__VITE_ASSET__Dp00O8Ge__"